import React from 'react';

export interface LocationDetailsData {
  streetName: string;
  streetNameCorrection: string;
}

interface LocationDetailsFormProps {
  formData: LocationDetailsData;
  onChange: (data: Partial<LocationDetailsData>) => void;
  showTitle?: boolean;
  title?: string;
  required?: boolean;
  className?: string;
}

const LocationDetailsForm: React.FC<LocationDetailsFormProps> = ({
  formData,
  onChange,
  showTitle = true,
  title = 'Dettagli della Posizione',
  required = true,
  className = ''
}) => {
  const handleFieldChange = (field: keyof LocationDetailsData, value: string) => {
    onChange({ [field]: value });
  };

  return (
    <div className={`bg-white rounded-lg shadow-md p-6 ${className}`}>
      {showTitle && (
        <h2 className="text-xl font-semibold mb-4">{title}</h2>
      )}
      
      <div className="grid md:grid-cols-2 gap-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Nome della Via {required && '*'}
          </label>
          <input
            type="text"
            value={formData.streetName}
            onChange={(e) => handleFieldChange('streetName', e.target.value)}
            required={required}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            placeholder="es. Via Roma, 123"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Correzione Nome Via
          </label>
          <input
            type="text"
            value={formData.streetNameCorrection}
            onChange={(e) => handleFieldChange('streetNameCorrection', e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            placeholder="Se diverso da Google Maps"
          />
        </div>
      </div>
    </div>
  );
};

export default LocationDetailsForm;